<template>
  <div class="page-wrap-w d-flex justify-content-center align-items-center">
    <div
      style="    padding: 30px;
    background-color: #ececec;
    border-radius: 4px;
    border: 1px solid #ccc;"
    >
      <div>
        <h1 style="margin-bottom: 20px; margin-top: 10px; font-weight:600">Login to GSPT Assessments</h1>
        <div class="alert alert-danger" v-show="error">
          <span>{{error}}</span>
        </div>
        <form @submit.prevent="submit" style="min-width: 600px">
          <div class="form-group">
            <input
              type="email"
              required
              placeholder="Email Address"
              class="form-control form-control-lg"
              v-model="email"
            >
          </div>
          <div class="form-group">
            <input
              type="password"
              required
              placeholder="Password"
              class="form-control form-control-lg"
              v-model="password"
            >
          </div>
          <button class="btn btn-primary btn-lg btn-block" :disabled="loading">
            <svg-loader/>
            <span>Submit</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "login",
  data() {
    return {
      loading: false,
      email: null,
      password: null,
      error: null
    };
  },
  methods: {
    submit() {
      this.loading = true;
      this.error = null;

      this.axios
        .post("/auth/local", {
          email: this.email,
          password: this.password
        })
        .then(res => {
          console.log(res);
          if (res.status === 201) {
            return this.$router.push("/verify/" + res.data.id);
          }

          this.$_login(res.data, this.email);
        })
        .catch(res => {
          this.error = "Invalid password and or username.";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    if (this.$route.query.sessionExpired) {
      this.error = "Session expired. Please reenter your login credentials.";
    }
  }
});
</script>
<style lang="scss" scoped>
.page-wrap-w {
  min-height: calc(100vh - 51px);
  width: 100vw;
}

.logo-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 1.5rem;
  font-weight: 600;
  color: #335db1;
  margin-bottom: 0;
}

.login-card {
  min-width: 29rem;

  .version-text {
    font-size: 0.875rem;
  }

  .forgotten-text {
    margin-top: 0.5rem;
    font-size: 0.75rem;

    a {
      font-weight: 600;
    }
  }
}
</style>
